import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';
import { getEffectiveTheme, toggleTheme } from '../lib/theme';

/**
 * ThemeToggle — sun/moon button in the topbar.
 *
 * Reads the current theme from localStorage and listens for the
 * `themechange` event so multiple toggles on the same page stay in sync.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState(getEffectiveTheme);

  useEffect(() => {
    function handler(e) {
      setTheme(e.detail.theme);
    }
    window.addEventListener('themechange', handler);
    return () => window.removeEventListener('themechange', handler);
  }, []);

  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={() => setTheme(toggleTheme())}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className="inline-flex items-center justify-center h-8 w-8 rounded-md text-fg-muted hover:text-fg hover:bg-surface-2 transition-colors"
    >
      {isDark ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
    </button>
  );
}